import * as swcHelpers from '@swc/helpers';
import { isDefined } from '@grandvisionhq/utils';
import { mapServerToVariantBase } from './map-server-to-variant-base.js';
import { getBrandModelAttributes } from '../utils/get-brand-model-attributes.js';
import { mapServerToAccessoriesSpecifications } from '../specification-mappers/map-server-to-accessories-specifications.js';

const mapServerToAccessoriesVariant = (serverProduct, slug, locale)=>{
    const { variants: serverVariants  } = serverProduct;
    if (!serverVariants || !serverVariants.length) {
        return;
    }
    const clientVariants = serverVariants.map((serverVariant)=>{
        var ref;
        const variantBase = mapServerToVariantBase(serverVariant, serverProduct, slug, locale);
        if (!variantBase) return;
        const otherFacet = serverVariant.variantTypeDetails.color.length === 0 && (serverVariant === null || serverVariant === void 0 ? void 0 : serverVariant.variantTypeDetails.brandModelColorCode) ? serverVariant === null || serverVariant === void 0 ? void 0 : serverVariant.variantTypeDetails.brandModelColorCode : undefined;
        const brandModelAttributes = getBrandModelAttributes(serverVariant);
        const pricePerUnit = serverVariant.variantTypeDetails.pricePerUnit ? {
            // FIXME: pricePerUnit is being returned as a decimal, but this is comparable with rest API response
            // and the deprecated pricePerLiter which is returned in cent amount. multiplying by 100 until price
            // values are consistent.
            amount: serverVariant.variantTypeDetails.pricePerUnit.amount * 100,
            currencyCode: serverVariant.variantTypeDetails.pricePerUnit.currencyCode
        } : undefined;
        var ref1;
        const accessory = swcHelpers.objectSpread({}, variantBase, brandModelAttributes, {
            variantType: 'accessories',
            pricePerUnit,
            facets: {
                color: serverVariant.variantTypeDetails.color[0],
                other: otherFacet
            },
            specifications: mapServerToAccessoriesSpecifications(serverVariant, serverProduct.brand),
            accessoryType: (ref1 = (ref = serverVariant.variantTypeDetails.accessoryType) === null || ref === void 0 ? void 0 : ref.displayName) !== null && ref1 !== void 0 ? ref1 : undefined
        });
        return accessory;
    });
    return clientVariants.filter(isDefined);
};

export { mapServerToAccessoriesVariant };
//# sourceMappingURL=map-server-to-accessories-variant.js.map
